export interface BillingEngineResponse<T> {
  statusCode: number;
  status: boolean;
  data: T;
}

export interface BillingEngineResponseWithMeta<T, M> extends BillingEngineResponse<T> {
  meta: M;
}

export interface PaginatedResponse {
  pagination: {
    last: number;
    current: number;
    perPage: number;
  };
  data: {
    total: number;
  };
  sorting: {
    by: string;
    order: string;
  };
}

// Errors

export interface BillingEngineErrorResponse<T = string> {
  statusCode: number;
  data?: {
    error: string;
    message: T;
  };
}

export type BillingEngineSuccessMessageResponse = BillingEngineResponse<{
  message: string;
}>;

export function isBillingEngineApiError(data: any): data is BillingEngineResponse<BillingEngineErrorResponse> {
  return data && !data.success;
}

export function isBillingEngineRequestError(data: any): data is BillingEngineErrorResponse {
  return data && !!data.error;
}
